import { render } from "./SKUDataTableListPage.vue?vue&type=template&id=4ba311f3&ts=true"
import script from "./SKUDataTableListPage.vue?vue&type=script&lang=ts"
export * from "./SKUDataTableListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__